// First stat shows a "just launched" badge instead of a fabricated books-created count.
export const STATS_LABELS = {
  EN: { booksCreated: "Just launched", rightsYours: "Rights Yours", delivery: "Delivery", languages: "Languages" },
  DA: { booksCreated: "Just launched", rightsYours: "Dine rettigheder", delivery: "Levering", languages: "Sprog" },
  DE: { booksCreated: "Gerade gestartet", rightsYours: "Ihre Rechte", delivery: "Lieferung", languages: "Sprachen" },
  FR: { booksCreated: "Tout juste lancé", rightsYours: "Droits à vous", delivery: "Livraison", languages: "Langues" },
  IT: { booksCreated: "Appena lanciato", rightsYours: "Diritti tuoi", delivery: "Consegna", languages: "Lingue" },
  ES: { booksCreated: "Recién lanzado", rightsYours: "Derechos tuyos", delivery: "Entrega", languages: "Idiomas" },
  PT: { booksCreated: "Recém-lançado", rightsYours: "Direitos seus", delivery: "Entrega", languages: "Idiomas" },
  NL: { booksCreated: "Net gelanceerd", rightsYours: "Rechten van jou", delivery: "Levering", languages: "Talen" },
  SE: { booksCreated: "Just lanserad", rightsYours: "Dina rättigheter", delivery: "Leverans", languages: "Språk" },
  PL: { booksCreated: "Świeży start", rightsYours: "Twoje prawa", delivery: "Dostawa", languages: "Języki" },
} as const;

export const STATS_VALUES = {
  EN: ["NEW", "100%", "< 1 Hour", "10"],
  DA: ["NY", "100%", "< 1 time", "10"],
  DE: ["NEU", "100%", "< 1 Stunde", "10"],
  FR: ["NOUVEAU", "100%", "< 1 heure", "10"],
  IT: ["NUOVO", "100%", "< 1 ora", "10"],
  ES: ["NUEVO", "100%", "< 1 hora", "10"],
  PT: ["NOVO", "100%", "< 1 hora", "10"],
  NL: ["NIEUW", "100%", "< 1 uur", "10"],
  SE: ["NY", "100%", "< 1 timme", "10"],
  PL: ["NOWY", "100%", "< 1 godz.", "10"],
} as const;

export function buildLandingStats(lang: string | null | undefined): [string, string][] {
  const code = String(lang || "EN").toUpperCase();
  const values = STATS_VALUES[code as keyof typeof STATS_VALUES] || STATS_VALUES.EN;
  const labels = STATS_LABELS[code as keyof typeof STATS_LABELS] || STATS_LABELS.EN;
  return [
    [values[0], labels.booksCreated],
    [values[1], labels.rightsYours],
    [values[2], labels.delivery],
    [values[3], labels.languages],
  ];
}
